import TambahkanFeeds from "./TambahkanFeeds";

export default TambahkanFeeds